<template>
	<div class="login">
		<HiqHeader class="login__header" @click="onHome" />
		<main class="login__main">
			<!-- Reset password -->
			<template v-if="reset">
				<ResetPasswordForm
					ref="reset"
					@submit="onResetSubmit"
					:loading="loading"
				/>
			</template>
			<!-- Forgot password -->
			<template v-else-if="forgot">
				<ForgotPasswordForm @submit="onForgotSubmit" :loading="loading" />
				<button class="login__forgot" @click="onRemember">Back to login</button>
			</template>
			<!-- Log in -->
			<template v-else>
				<h1>Please log in to continue</h1>
				<LoginForm @submit="onSubmit" :loading="loading" />
				<button class="login__forgot" @click="onForgot">
					Forgot your password?
				</button>
			</template>
		</main>
		<HiqFooter hide-about />
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import HiqHeader from '@/components/shared/HiqHeader'
import LoginForm from '@/components/admin/LoginForm'
import ForgotPasswordForm from '@/components/admin/ForgotPasswordForm'
import ResetPasswordForm from '@/components/admin/ResetPasswordForm'
import HiqFooter from '@/components/main/HiqFooter'

export default {
	name: 'Login',
	data() {
		return {
			loading: false,
			forgot: false
		}
	},
	computed: {
		reset() {
			return Boolean(this.$route.query.code)
		}
	},
	methods: {
		...mapActions('auth', ['logIn']),
		onHome() {
			this.$router.push({ name: 'Home' })
		},
		onForgot() {
			if (!this.loading) this.forgot = true
		},
		onRemember() {
			if (!this.loading) this.forgot = false
		},
		async onForgotSubmit(form) {
			this.loading = true
			const body = JSON.stringify(form)
			try {
				await this.post('/auth/forgot-password', { body })
				this.toast('A password reset link has been sent to your email.')
				this.forgot = false
			} catch (err) {
				this.toastErr('Failed to reset your password, please try again later.')
			}
			this.loading = false
		},
		async onResetSubmit(form) {
			this.loading = true
			const body = JSON.stringify(form)
			try {
				await this.post('/auth/reset-password', { body })
				this.toast('Your password was reset successfully.')
				this.$router.replace({ name: 'Login' })
			} catch (err) {
				this.toastErr('Failed to reset your password, please try again later.')
			}
			this.loading = false
		},
		async onSubmit(form) {
			this.loading = true
			const success = await this.logIn(form)
			if (success) {
				this.$router.push({ name: 'Current Campaign' })
			} else {
				this.toastWarn(
					'Error logging in, please check your credentials and try again'
				)
			}
			this.loading = false
		}
	},
	mixins: [api, toast],
	components: {
		HiqHeader,
		LoginForm,
		ForgotPasswordForm,
		ResetPasswordForm,
		HiqFooter
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.login {
	display: flex;
	min-height: 100vh;
	flex-direction: column;

	&__header {
		background-color: $blue-30;
	}
	&__main {
		flex-grow: 1;
		padding: 1.5rem;
	}

	&__forgot {
		appearance: none;
		border: none;
		background: none;
		display: inline-block;
		cursor: pointer;
		color: $blue-73;
	}
}
</style>
